import React, { useEffect } from "react";
import { Spinner } from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import ParsoIco from "../../../svgs/ParsoIco";
import { api } from "../../api/api";
import { Types } from "../../redux/actionTypes";
import { sortItems } from "../../common/utilities/utilities";
import {
  defaultCatch,
  defaultSuccess,
} from "../../redux/actions";

function LoadPage(props) {
  const { defaultCatch, defaultSuccess } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const _defaultCatch = (error) => defaultCatch(error, history);

  const fetchSitesForRooms = () => {
    return api
      .get("/workplace/sites", { params: { desks: false, rooms: true } })
      .then(defaultSuccess)
      .then(({ data }) => {
        if (!data.success) return;
        dispatch({
          type: Types.SET_SITES_ROOMS,
          payload: sortItems(data.sites),
        });
      })
      .catch(_defaultCatch);
  };

  useEffect(() => {
    Promise.all([fetchSitesForRooms()])
      .then(() => {
        history.replace("/");
      })
      .catch((error) => console.error("Error fetching data", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="LoadPage">
      <div className="box-loading">
        <ParsoIco width={75} />
        <Spinner size="huge" />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    enabledWorkplace: state.profile.enabled_workplace,
    enabledRoom: state.profile.enabled_room_reservations,
    enabledDesk: state.profile.company.enabled_desk_reservations,
  };
};

const mapDispatchToProps = {
  defaultSuccess,
  defaultCatch,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadPage);
